module.exports = __webpack_public_path__ + "static/media/noun_silhouette.628279de.png";